export default __webpack_public_path__ + "static/media/modesp04.44aa206a.png";